import React from 'react';
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import './styles.scss'

const CompanyInformation = (props) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allDataYaml {
            edges {
              node {
                top {
                  company {
                    heading
                    information {
                      key
                      value
                    }
                  }
                  vc {
                    heading
                  }
                }
                language
              }
            }
          }
          vcLogoImages: allFile(filter: {relativePath: {glob: "logos_vc/*"}}, sort: {fields: name}) {
            nodes {
              name
              publicURL
            }
          }
          hiringCTAImageJa: file(relativePath: {eq: "top/hiring-cta_ja.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 760) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          hiringCTAImageEn: file(relativePath: {eq: "top/hiring-cta_en.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 760) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          hiringCTASpImageJa: file(relativePath: {eq: "top/hiring-cta-sp_ja.png"}) {
            name
            childImageSharp {
              fluid(maxWidth: 343) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      `}
      render={({ allDataYaml: { edges }, vcLogoImages, hiringCTAImageJa, hiringCTAImageEn, hiringCTASpImageJa}) => {
        const { language } = props
        const { node: { top: { company, vc } } } = edges.find(({node}) => node.language === language)
        const { heading: vcHeading } = vc
        const { heading: companyHeading, information } = company

        const hiringCTAImage = language === "ja" ? hiringCTAImageJa : hiringCTAImageEn
        const hiringLink = language === "ja" ? "/ja/careers" : "/careers"

        return <div className="top-company-information">
          <h2>{vcHeading}</h2>
          <div className="top-company-vc">
            <div className="container-fluid">
              <ul className="row">
                {
                  vcLogoImages.nodes.map((logo, idx) => {
                    return <li key={idx} className="company-vc-col col-6 col-md-4 col-xl-2">
                      <div className="company-vc-logo">
                        <img src={logo.publicURL} loading="lazy" decoding="async" alt={logo.name} />
                      </div>
                    </li>
                  })
                }
              </ul>
            </div>
          </div>
          <h2 className="company-info-heading">{companyHeading}</h2>
          <div className="d-table info-table">
            {
              information.map((info, idx) => {
                return <div className="d-table-row" key={idx}>
                  <div className="d-table-cell info-key">{info.key}</div>
                  <div className="d-table-cell info-val">{info.value}</div>
                </div>
              })
            }
          </div>
          <div className="hiring-cta d-none d-md-block"><Link to={hiringLink}><Img fluid={hiringCTAImage.childImageSharp.fluid} alt={hiringCTAImage.name} /></Link></div>
          <div className="hiring-cta d-block d-md-none "><Link to={hiringLink}><Img fluid={hiringCTASpImageJa.childImageSharp.fluid} alt={hiringCTASpImageJa.name} /></Link></div>
        </div>
      }}
    />
  )
}

export default CompanyInformation;
